import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

/**
 * AroonOsc (Oscilador Aroon, FML.AroonOsc) — painel próprio: linha do
 * oscilador + linha de referência em zero (a série "Ref" constante do pacote
 * original). yAccessor(d) retorna o valor do oscilador.
 */
class AroonOscSeries extends Component {
  render() {
    const { yAccessor, stroke, strokeZeroLine, className } = this.props;
    return (
      <g className={className}>
        <LineSeries yAccessor={yAccessor} stroke={stroke} fill="none" />
        <StraightLine yValue={0} stroke={strokeZeroLine} />
      </g>
    );
  }
}

AroonOscSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  stroke: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeZeroLine: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
};

AroonOscSeries.defaultProps = {
  stroke: { color: "#FF0000" },
  strokeZeroLine: { color: "#FFFF00", dash: "Solid", width: 1, opacity: 1 },
  className: "react-stockcharts-aroonosc-series",
};

export default AroonOscSeries;
